import React from 'react'

import styled from '@emotion/styled'
import Image from '../../atoms/image';
import { mq, text, black03, green01 } from '../../../_style';
import Caption from '../../atoms/caption';
import Text from '../../atoms/text';

const Container = styled.div`
  h4 {
    color: ${black03};
    position: relative;
    padding-left: 12px;
    font-weight: bold;
    ${text('18px', 32 / 18)}
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 7px;
      bottom: 7px;
      width: 5px;
      margin: auto;
      background-color: ${green01};
    }
  }

  p {
    margin-top: 20px;
  }
`
const CaptionContainer = styled.div`
  margin-top: 20px;
`

export default class DetailTexts extends React.Component {
  render() {
    return(
      <Container>
        <h4>{this.props.title}</h4>
        <Text>{this.props.children}</Text>
        <CaptionContainer>

          {this.props.captions && this.props.captions.map((item, index) => (
            <Caption key={index}>{item}</Caption>
          ))}
        </CaptionContainer>
      </Container>
    )
  }
}
